<div *ngIf="selectedPatient$ | async as selectedPatient">
  <div *ngIf="queryFilter$ | async as queryFilter"><!--{{queryFilter | json}}-->
  <!--button (click)="testUpdateMessage(selectedPatient)">UPDATE</button-->
  <ng-message-list
      [reportType]="'patient'"
      [messages]="personMessages$ | async"
      [loading]="loading$ | async"
      (loadDataOnScroll)="getMoreMessagesOnScroll(selectedPatient, queryFilter)">
  </ng-message-list>
  </div>
</div>